import React, { Component } from "react"
import { Link } from "react-router-dom"
import moment from "moment"
import Select, { components } from "react-select"
import { Query } from "react-apollo"
import Button from "../Button"
import Login from "../Login"
import ForgotPassword from "../ForgotPassword"
import AccountModal from "../AccountModal"
import AccountLinks from "../AccountLinks"
import * as imageAsset from "../../shared/images"
import { GetVendorList } from "./queries"
import GlobalSearch from "../GlobalSearch"
import { debounce } from "throttle-debounce"
import { BetaWaitlist } from "../BetaWaitlist"

import "./topBar.scss"

class TopBar extends Component {
  constructor(props) {
    super(props)

    this.setAndTrackDebouncedSearchKeyword = debounce(400, (keyword) => {
      this.setState({ debouncedSearchKeyword: keyword })

      if (keyword) {
        this.props.trackEvent("Vendor Search", {
          event: "input",
          searchKeyword: keyword,
        })
      }
    })

    this.state = {
      isAccountMenuOpen: false,
      mobileSearchActive: false,
      isUpgradeModalOpen: false,
      forgotPassword: false,
      searchKeyword: "",
      debouncedSearchKeyword: "",
      hasMoreVendors: true,
    }
  }

  toggleAccountMenu = () => {
    this.setState((prevState) => {
      return {
        isAccountMenuOpen: !prevState.isAccountMenuOpen,
        forgotPassword: false,
      }
    })
  }

  setUpgradeModalState = (isUpgradeModalOpen) =>
    this.setState({ isUpgradeModalOpen })

  toggleForgotPassword = () => {
    this.setState(({ forgotPassword }) => ({
      forgotPassword: !forgotPassword,
    }))
  }

  accountMenu = () => {
    let { isAccountMenuOpen, forgotPassword } = this.state
    let accountModalContent

    if (this.props.data.viewer.isUserAuthenticated) {
      accountModalContent = (
        <AccountLinks {...this.props} close={this.toggleAccountMenu} />
      )
    } else if (forgotPassword) {
      accountModalContent = (
        <ForgotPassword
          {...this.props}
          closeModal={this.toggleAccountMenu}
          clearFields={!isAccountMenuOpen}
          login={this.toggleForgotPassword}
          onSuccess={this.toggleAccountMenu}
        />
      )
    } else {
      accountModalContent = (
        <Login
          {...this.props}
          closeModal={this.toggleAccountMenu}
          clearFields={!isAccountMenuOpen}
          forgotPassword={this.toggleForgotPassword}
          topBar={true}
        />
      )
    }

    return (
      <AccountModal
        isMenuOpen={isAccountMenuOpen}
        parentElem="TopBar"
        close={this.toggleAccountMenu}
      >
        {accountModalContent}
      </AccountModal>
    )
  }

  nameAbbr = (name) => {
    const fullName = name ? name.split(" ") : []
    let abbrName = []

    for (let i in fullName) {
      abbrName.push(fullName[i].charAt(0))
    }
    return abbrName.join(".")
  }

  toggleSearch = () => {
    let mobileSearch = document.querySelector("#mobile-search-container")
    mobileSearch.classList.toggle("active")

    let searchIcon = document.querySelector("#mobile-search")
    searchIcon.classList.toggle("active")

    this.setState((prevState) => ({
      mobileSearchActive: !prevState.mobileSearchActive,
    }))
  }

  preventDefaultScroll = () => {
    let pageContainer = document.querySelector("#page-container")
    pageContainer.setAttribute("style", "overflow:hidden")
  }

  toggleMobileSideBar = () => {
    let sideBar = document.querySelector(".sidebar-container")
    sideBar.classList.toggle("active")
    this.preventDefaultScroll()
  }

  toggleMobileFilter = () => {
    let filter = document.querySelector(".filter-container")
    filter.classList.toggle("active")
    this.preventDefaultScroll()
  }

  collapseElements = () => {
    let winWidth = window.innerWidth

    if (winWidth > 600) {
      document.querySelector(".sidebar-container").classList.remove("active")
    }
  }

  /**
   * [eventThroller description]
   * Throttle events to only run at 15fps
   */
  eventThroller = () => {
    let eventTimeout
    // ignore resize events as long as an actualResizeHandler execution is in the queue
    if (!eventTimeout) {
      eventTimeout = setTimeout(() => {
        eventTimeout = null
        this.collapseElements()
      }, 66)
    }
  }

  componentDidMount() {
    window.addEventListener("resize", this.eventThroller)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.eventThroller)
  }

  onRequestSubscription = () => {
    this.props.trackEvent("Requested subscription plan", {
      planName: "ETR MASTER",
    })
  }

  renderVendorSearch = () => {
    const formattedOptions = (vendors) => {
      return vendors.map((vendor) => {
        return { label: vendor.name, value: vendor.slug }
      })
    }

    const DropdownIndicator = ({ ...props }) => {
      return (
        <components.DropdownIndicator {...props}>
          <i className="fas fa-search" />
        </components.DropdownIndicator>
      )
    }

    return (
      <Query
        query={GetVendorList}
        fetchPolicy={"cache-and-network"}
        variables={{ search: this.state.debouncedSearchKeyword }}
      >
        {({ data, loading, error, fetchMore }) => {
          if (error) console.log("Error while getting list of vendors.")

          if (data && data.vendors) {
            const loadMoreVendors = () => {
              if (this.state.hasMoreVendors) {
                fetchMore({
                  variables: {
                    starting_after:
                      data.vendors && data.vendors.length > 0
                        ? data.vendors[data.vendors.length - 1].id
                        : null,
                  },
                  updateQuery: (prev, { fetchMoreResult }) => {
                    if (!fetchMoreResult) return prev
                    return Object.assign({}, prev, {
                      vendors: [...prev.vendors, ...fetchMoreResult.vendors],
                    })
                  },
                }).then(({ data, loading, error }) => {
                  if (!error && !loading && data.vendors.length === 0) {
                    this.setState({ hasMoreVendors: false })
                  }
                })
              }
            }

            return (
              <div className="vendor-search-container">
                <label
                  htmlFor="vendor-searchbar"
                  className="vendor-search-label"
                >
                  Search Vendors
                </label>
                <Select
                  inputId="vendor-searchbar"
                  placeholder={""}
                  classNamePrefix={"vendor-select"}
                  className={"vendor-select-container"}
                  components={{ DropdownIndicator }}
                  styles={{
                    noOptionsMessage: (props) => ({
                      ...props,
                      color: "#495057",
                      fontWeight: 700,
                      fontSize: "1.4rem",
                      textAlign: "left",
                    }),
                  }}
                  noOptionsMessage={() => "No Results Found"}
                  value={loading ? "Loading..." : this.state.searchKeyword}
                  options={formattedOptions(data.vendors)}
                  filterOption={false}
                  onInputChange={(e) => {
                    this.setState({
                      searchKeyword: e,
                      hasMoreVendors: true,
                    })

                    this.setAndTrackDebouncedSearchKeyword(e)
                  }}
                  onMenuScrollToBottom={loadMoreVendors}
                  onChange={(e) => {
                    this.props.trackEvent("Vendor Search", {
                      event: "select",
                      vendor: e.value,
                    })
                    this.props.history.push("/vendor/" + e.value)
                  }}
                />
              </div>
            )
          }
          return null
        }}
      </Query>
    )
  }

  render = () => {
    let {
      minimal,
      data: { viewer },
    } = this.props

    let topButtons = []

    if (viewer && viewer.canUpgrade) {
      topButtons.push({
        fullWidth: true,
        classes: ["gradient", "small-caps"],
        action: () =>
          this.props.openInquireModal(
            this.props.serviceType.UpgradePlan,
            "Top Bar: Inquire For Pricing Button"
          ),
        text: "INQUIRE FOR PRICING",
        "data-cy": "top-bar-inquire-button",
      })
    }

    let buttonStyle = {
      flexGrow: topButtons.length < 2 ? 1 : 3,
    }

    // this date will need to update when we deploy
    const newUserCreationDate = moment("09-20-2023", "MM-DD-YYYY").toISOString()
    const userCreationDate = viewer.createdAt
    const isCurrentUser = moment(userCreationDate).isBefore(newUserCreationDate)

    return (
      <React.Fragment>
        <div
          id="TopBar"
          data-cy="top-bar"
          className={`topbar-container ${minimal ? "minimal" : "regular"}`}
        >
          {minimal && (
            <Link className="topbar-logo" to="/">
              <img src={imageAsset.colorLogo} className="logo-sm" alt="ETR" />
            </Link>
          )}
          <div id="mobile-menu" onClick={this.toggleMobileSideBar}>
            <span className="glyphicon glyphicon-menu-hamburger" />
            <p>Menu</p>
          </div>
          {!!topButtons.length && (
            <div className="topbar-item-buttons" style={buttonStyle}>
              {topButtons.map((button, i) => (
                <Button key={i} {...button} />
              ))}
            </div>
          )}
          <div className="topbar-item-mobile">
            <div className="logo-container">
              <Link to="/">
                <img
                  className="logo"
                  src={imageAsset.lightLogo}
                  alt="ETR logo"
                />
              </Link>
            </div>
            <div id="mobile-search" onClick={this.toggleSearch}>
              <span
                className={
                  this.state.mobileSearchActive
                    ? "icon icon-close"
                    : "icon glyphicon glyphicon-search"
                }
              />
            </div>
          </div>
          <div className="topbar-item-search">
            <div
              id="mobile-search-container"
              className={this.state.mobileSearchActive ? "active" : ""}
            >
              {/* Hide the waitlist for now...
              {!viewer.joinedBetaWaitlist && (
                <BetaWaitlist type="button" viewer={viewer} />
              )} */}
              <GlobalSearch
                algoliaSearchKey={viewer.algoliaSearchKey}
                showToolTip={isCurrentUser}
                userId={viewer.userId}
              />
            </div>
          </div>
          <div id="accountMenu" className="topbar-item-menu">
            <Button
              fullWidth
              classes={["btn-light", "btn-outline"]}
              action={this.toggleAccountMenu}
              data-cy="user-menu-button"
            >
              {viewer && viewer.isUserAuthenticated ? (
                <div>
                  <span className="mobile-username">
                    {this.nameAbbr(viewer.name)}
                  </span>
                  <span className="desktop-username">{viewer.name}</span>
                  <i className="icon glyphicon glyphicon-menu-down" />
                </div>
              ) : (
                <div>
                  LOG IN <i className="icon glyphicon glyphicon-menu-down" />{" "}
                </div>
              )}
            </Button>
            {this.accountMenu()}
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default TopBar
